import { defineComponent as _defineComponent } from 'vue'
export interface IAlertBlockProps {
        color: 'green' | 'yellow' | 'red',
        border?: boolean;
        size?: 'big' | 'small',
    }
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AlertBlock',
  props: {
    color: null,
    border: { type: Boolean, default: false },
    size: { default: 'big' }
  },
  setup(__props: any) {


    


return { __sfc: true, }
}

})